// extracted by mini-css-extract-plugin
export default {"container":"app_container__yhzPe","box":"app_box__z4fIu","overlay":"app_overlay__FCZrT","user":"app_user__9p3sA","badges":"app_badges__DAY-6","badge":"app_badge__-w4UA"};